<template>
  <div class="logout-or-continue-modal">
    <div
      class="content d-flex flex-column justify-content-start align-items-start"
    >
      <h2>{{ title }}</h2>
      <span class="mt-3">{{ description }}</span>
    </div>
    <hr />
    <div class="footer d-flex justify-content-between align-items-center">
      <HMButton color="outline-light-gray" @click="logoutHandler">
        <span>{{ $t('GENERAL.BUTTON.LOGOUT') }}</span>
      </HMButton>
      <HMButton color="brand" @click="continueHandler">
        <span>{{ $t('GENERAL.BUTTON.CONTINUE') }}</span>
      </HMButton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LogoutOrContinueModal',
  props: {
    logoutFn: null,
    continueFn: null,
    title: {
      default() {
        return this.$t('GENERAL.TITLE.YOU_ALREADY_HAVE_MARVELOUS_ACCOUNT');
      },
    },
    description: {
      default() {
        return this.$t(
          'GENERAL.TEXT.LOGOUT_TO_CREATE_NEW_ACCOUNT_OR_CONTINUE_TO_EXISTING_ACCOUNT'
        );
      },
    },
  },
  methods: {
    async logoutHandler() {
      await this.logoutFn();
      this.$emit('close');
    },
    async continueHandler() {
      await this.continueFn();
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';
</style>
